import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const painPoints = ['Dormís… pero te despertás agotada igual', 'Comés igual que antes, pero tu cintura cambió', 'Vivís cansada mentalmente, incluso cuando descansás.', 'Ansiedad, antojos, hinchazón que no ceden'];
  return <section className="bg-gradient-hero min-h-0 md:min-h-screen flex items-start pt-10 pb-12 md:pt-12 md:pb-16 relative overflow-hidden" data-id="element-101">
      <div className="absolute left-[8%] md:left-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-102" />
      <div className="absolute right-[8%] md:right-[20%] top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-gold/15 to-transparent" data-id="element-103" />

      <div className="max-w-[1400px] mx-auto px-5 md:px-8 w-full relative z-10" data-id="element-104">
        <div className="flex flex-col items-center text-center" data-id="element-105">
          <p className="uppercase tracking-[0.3em] text-[12px] text-[#C8A870] font-semibold mb-7" data-id="element-106">
            Protocolo H.E.R.
          </p>

          <h1 className="font-display font-semibold leading-[1.05] tracking-tight max-w-4xl text-[#F0E8D8]" data-id="element-107">
            <span className="block text-[44px] md:text-6xl" data-id="element-108">
              Volvé a sentirte
            </span>
            <span className="block italic text-gradient-gold text-[40px] md:text-6xl my-1" data-id="element-109">
              vos
            </span>
            <span className="block text-[44px] md:text-6xl" data-id="element-110">en 21 días</span>
          </h1>

          <p className="font-body md:text-[18px] mt-6 tracking-wide text-[#F0E8D8] text-[17px]" data-id="element-111">
            Tu cuerpo cambió. Y no es falta de disciplina.
          </p>

          <p className="mt-7 uppercase tracking-[0.18em] text-[12px] md:text-[13px] text-[#C8A870] font-semibold leading-[2]" data-id="element-112">
            ✦ Más energía&nbsp;&nbsp;&nbsp;✦ Menos hinchazón &nbsp;✦ Hábitos simples
          </p>

          <div className="relative mt-12 mb-10 w-full max-w-[19rem]" data-id="element-113">
            <div className="absolute inset-0 -z-10 flex items-center justify-center pointer-events-none" data-id="element-114">
              <div className="w-[75%] h-[75%] rounded-full bg-gold/10 blur-[80px]" data-id="element-115" />
            </div>

            <div className="relative text-center" data-id="element-116">
              <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ebook_430x.webp?v=1780543244" alt="Protocolo H.E.R." width="340" height="456" loading="eager" fetchPriority="high" decoding="async" className="w-full max-w-[340px] mx-auto block rounded-[4px] shadow-[0_25px_60px_rgba(0,0,0,0.45)]" data-id="element-117" />
            </div>
          </div>

          <div className="max-w-md" data-id="element-118">
            <p className="font-display italic md:text-[26px] text-[23px] text-[#F0E8D8]" data-id="element-119">
              Sin dietas extremas. Sin rutinas imposibles.
            </p>

            
          </div>

          <img src="https://cdn.shopify.com/s/files/1/0730/1614/8145/files/ChatGPT_Image_9_jun_2026_02_48_17_p.m_430x.jpg?v=1781031076" alt="Mujer reflexionando" loading="lazy" decoding="async" className="w-full max-w-[430px] mx-auto rounded-xl my-8" data-id="element-120" /><div className="mt-8 text-center max-w-md mx-auto" data-id="element-121">
  <h3 className="font-display text-[32px] leading-tight text-foreground" data-id="element-122">
    ¿Te reconocés en alguna de estas situaciones?
  </h3>

  <ul className="mt-8 space-y-4 text-left" data-id="element-123">
    <li className="font-body text-[18px] text-foreground/80" data-id="element-124">
      ✓ Dormís pero no descansás.
    </li>

    <li className="font-body text-[18px] text-foreground/80" data-id="element-125">
      ✓ Tu cintura cambió aunque comés parecido.
    </li>

    <li className="font-body text-[18px] text-foreground/80" data-id="element-126">
      ✓ Hay días donde no te sentís vos.
    </li>

    <li className="font-body text-[18px] text-foreground/80" data-id="element-127">
      ✓ Ansiedad, antojos e hinchazón.
    </li>
  </ul>

  <div className="mt-10" data-id="element-128">
    <p className="font-display text-[34px] leading-tight text-foreground" data-id="element-129">
      No necesitás más esfuerzo.
    </p>

    <p className="font-display italic text-[#C8A870] text-[30px] leading-tight mt-2" data-id="element-130">
      Necesitás una estrategia para esta etapa.
    </p>
  </div>
</div>

          <section className="w-full max-w-[500px] mx-auto mt-8 overflow-hidden" aria-label="Biblioteca H.E.R." data-id="element-131">
            <p className="text-center tracking-[0.22em] uppercase text-[#c9a96e] mb-2 text-[13px]" data-id="element-132">
              Biblioteca Digital H.E.R.
            </p>

            <h2 className="text-center font-serif text-[#f5f0e8] m-0 text-[31px]" data-id="element-133">
              Tu sistema completo
              <br data-id="element-134" />
              <em className="text-[#c9a96e] italic" data-id="element-135">en un solo lugar</em>
            </h2>

            <p className="text-center text-[#f5f0e8]/70 max-w-[330px] mx-auto mt-3 mb-5 font-[500] text-[16px]" data-id="element-136">
              Alimentación, movimiento, descanso y seguimiento en un solo lugar.
            </p>

            <div className="relative w-full overflow-hidden" data-id="element-137">
              <div className="flex gap-3 overflow-x-auto snap-x snap-mandatory px-[22px] pb-1 scrollbar-hide" data-id="element-138">
                {[{
                module: 'recetario',
                title: 'Recetario H.E.R.',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/sOWIBzOpm0inWncyzKYoM_430x.jpg?v=1780543245',
                pos: 'object-[center_30%]',
                alt: 'Recetario H.E.R.'
              }, {
                module: 'tracker',
                title: 'Tracker Premium',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/v5gVLGm07qY3WP7hCr5Mp_430x.jpg?v=1780543245',
                pos: 'object-[center_18%]',
                alt: 'Tracker Premium H.E.R.'
              }, {
                module: 'movement',
                title: 'H.E.R. Movement',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/S8SNVUZHdzf8t092yIlAK_430x.jpg?v=1780543245',
                pos: 'object-[center_34%]',
                alt: 'H.E.R. Movement'
              }, {
                module: 'organizacion',
                title: 'Organización Inteligente',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/1I1NNttJTHz_ql3yYujuX_430x.jpg?v=1780543245',
                pos: 'object-[center_18%]',
                alt: 'Organización Inteligente'
              }, {
                module: 'noche',
                title: 'Noche en Calma',
                img: 'https://cdn.shopify.com/s/files/1/0730/1614/8145/files/qushb3WzLl3BYpA9n1eL_430x.jpg?v=1780543244',
                pos: 'object-[center_42%]',
                alt: 'Noche en Calma'
              }].map(item => <article key={item.module} className="shrink-0 basis-[70%] snap-center border border-[#c9a96e]/20 rounded-[18px] bg-[#141210] overflow-hidden" data-id="element-139">
                    <div className="h-[220px] overflow-hidden bg-[#090807]" data-id="element-140">
                      <img src={item.img} alt={item.alt} loading="lazy" decoding="async" className={`w-full h-full object-cover ${item.pos}`} data-id="element-141" />
                    </div>

                    <div className="px-[18px] py-3" data-id="element-142">
                      <h3 className="font-serif text-[22px] leading-[1.08] text-[#f5f0e8] text-center" data-id="element-143">
                        {item.title}
                      </h3>
                    </div>
                  </article>)}
              </div>
            </div>

            <p className="text-center text-[#f5f0e8]/70 max-w-[330px] mx-auto mt-4 font-[500] text-[15px]" data-id="element-144">
              <strong className="text-[#e8d5b0] font-medium text-[15px]" data-id="element-145">
                ✦ Acceso completo a H.E.R. por $12.000 ✦
              </strong>
            </p>
          </section>

          <div className="pt-10 flex flex-col items-center w-full max-w-md space-y-4" data-id="element-146">
            <CTAButton onClick={scrollToOffer} data-id="element-147">
              Acceder al Protocolo H.E.R.
            </CTAButton>

            <p className="uppercase tracking-[0.14em] md:text-[12px] font-body text-center text-[11px] text-[#C8A870]" data-id="element-148">
              ✦Acceso inmediato&nbsp;✦Garantía 30 días&nbsp;✦Pago seguro&nbsp;✦3 CUOTAS DE
              $4.000 mercado pago
            </p>
          </div>

          <div className="mt-14 w-full max-w-xl" data-id="element-149">
            <div className="card-premium p-6 backdrop-blur-sm text-left" data-id="element-150">
              <p className="text-[11px] tracking-[0.2em] uppercase text-[#C8A870] font-semibold mb-3" data-id="element-151">
                Una alumna dijo:
              </p>

              <p className="italic text-[#F5EFE4] text-[17px]" data-id="element-152">
                “Por primera vez sentí que estaba siguiendo un plan pensado
                para esta etapa de mi vida.”
              </p>

              <p className="mt-4 text-[15px] text-[#E8DCC8]" data-id="element-153">
                — Laura, 52 · Argentina
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}